import { ifElse, isEmpty as _isEmpty, always, groupWith } from 'ramda';

import { BonusGroup, BonusI } from 'api/cms/bonuses';

type BonusItemType = BonusI & BonusGroup;

export const splitBonuses = (
  bonuses: Array<BonusItemType>
): Array<BonusI[] & BonusGroup[]> => {
  return ifElse(
    _isEmpty,
    always([]),
    groupWith(
      (bonus1: BonusItemType, bonus2: BonusItemType) =>
        !!bonus1.bonuses === !!bonus2.bonuses
    )
  )(bonuses);
};

export const encrypt = (
  object: object | string | number,
  encryptKey: string
) => {
  const encJson = CryptoJS.AES.encrypt(
    JSON.stringify(object),
    encryptKey
  ).toString();
  const encData = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(encJson)
  );
  return encData;
};

export function decrypt<T = any>(word: string, key: string): T | undefined {
  try {
    const decData = CryptoJS.enc.Base64.parse(word).toString(CryptoJS.enc.Utf8);
    const bytes = CryptoJS.AES.decrypt(decData, key).toString(
      CryptoJS.enc.Utf8
    );
    return JSON.parse(bytes);
  } catch {
    return;
  }
}

export function setCookie(name: string, value: string, days: number) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

export function getCookie(name: string) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export const isEmpty = (value: any) => value == null || value === '';

export const notEmpty = (value: any) => !isEmpty(value);

export const getRandom = (min = 1.8, max = 2.4): number => {
  return Number((Math.random() * (max - min + 1) + min).toFixed(1));
};

export const getRandomNumber = (from: number, to: number) =>
  Math.floor(Math.random() * to) + from;

export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getUuidAndSetToLocalStorage() {
  if (!localStorage.getItem('uuid')) {
    localStorage.setItem('uuid', uuid());
  }

  return localStorage.getItem('uuid') as string;
}

export function getStag() {
  const params = Object.fromEntries(
    new URLSearchParams(window.location.search)
  );

  return params.stag || '';
}

export function getFullUrl() {
  return window.location.origin + window.location.pathname;
}

export function getSessionIdParameter() {
  return `?session_id=${localStorage.getItem('uuid')}`;
}

export function getCtaButtonHrefWithSessionId() {
  return `/users/sign_up${getSessionIdParameter()}`;
}

export const hasTranslation = (t: (key: string) => string, key: string) =>
  t(key) !== key;
